import React from "react";
import {
  PropertyListingView,
  RENTED_PROPERTY_UNINFORMED_LABEL,
  formatAreaInlinePart,
  getPropertyInlineMetaParts,
} from "../utils/rentedPropertyDisplay";

interface PropertyInlineSummaryProps {
  listing: PropertyListingView;
  className?: string;
}

export default function PropertyInlineSummary({
  listing,
  className = "",
}: PropertyInlineSummaryProps) {
  const metaParts = getPropertyInlineMetaParts(listing.unit);
  const hasArea = listing.areaLabel !== RENTED_PROPERTY_UNINFORMED_LABEL;

  return (
    <p className={`text-xs leading-relaxed ${className}`.trim()}>
      <span className="text-[#8b949e]">{listing.streetAddress}</span>
      {metaParts.map((part) => (
        <React.Fragment key={part}>
          <span className="text-[#6e7681]"> · </span>
          <span className="text-[#c9d1d9]">{part}</span>
        </React.Fragment>
      ))}
      {(hasArea || listing.areaLabel) && (
        <>
          <span className="text-[#6e7681]"> · </span>
          <span
            className={
              hasArea ? "font-medium text-[#6ea8ff]" : "text-[#8b949e]"
            }
          >
            {formatAreaInlinePart(listing.areaLabel)}
          </span>
        </>
      )}
    </p>
  );
}
